import dayjs from 'dayjs';

export const getCurrentCalendarDate = () => dayjs().startOf('day');

export const getYesterdayCalendarDate = () => getCurrentCalendarDate().subtract(1, 'day');
